import { cn } from "@/lib/utils";
import { useLocationInfo } from "@/hooks/useLocationInfo";

function Footer({
  locationId,
  className,
}: {
  locationId: string;
  className?: string;
}) {
  const { data: locationInfo } = useLocationInfo(locationId);
  return (
    <footer
      className={cn(
        "text-xs text-muted-foreground bg-muted px-4 pb-32 pt-12",
        className
      )}
    >
      <div className="flex flex-col justify-center items-center gap-y-2">
        <div className="flex flex-col gap-y-2 justify-self-start self-start">
          <p>
            Powered by{" "}
            <a href="https://table.taxi" target="_blank">
              Table Taxi
            </a>
          </p>
          {locationInfo && (
            <>
              <p>Served at {locationInfo.name}</p>
              <p>CVR: {locationInfo.cvr}</p>
            </>
          )}
          <p>
            Contact Support:{" "}
            <a href="mailto:support@table.taxi" className="underline">
              support@table.taxi
            </a>
          </p>
        </div>

        <div className="flex flex-wrap gap-2 self-start justify-self-start">
          <a
            href={`https://assets.table.taxi/global/terms.pdf`}
            target="_blank"
            className="underline"
          >
            Handelsbetingelser
          </a>
          <a
            href={`https://assets.table.taxi/global/privacy.pdf`}
            target="_blank"
            className="underline"
          >
            Privatlivspolitik
          </a>
        </div>

        <img
          src="/images/cardlogos.png"
          height="24"
          className="w-auto h-[24px]"
          alt="Supported payment methods: Visa, Mastercard and Dankort"
        />

        <img
          src="/images/sst-alcohol.png"
          height="250"
          width="250"
          alt=""
          className="mt-4"
        />
      </div>
    </footer>
  );
}

export { Footer };
